function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 16a15 15 0 1030 0 15 15 0 00-30 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.225 24.226l-6.774-6.774m-2.903-1.968a1.936 1.936 0 103.872-.002 1.936 1.936 0 00-3.872.002h0zM15 7.742v5.806"
}));

function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgPending;